import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const importFileService = {
  importFile
};

function importFile(import_data){
  return (
    axios
      .post(
        `${apiEndpoint.importFiles}/import-excel`,
        import_data,
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}